import { LocatableEntity } from "@ots-frontend/ots-data";
import { Marker, MarkerIcon, MarkerProps } from "../Marker/Marker";

export type EntityMarkerProps<T extends LocatableEntity> =
  Omit<MarkerProps, "icon" | "onHover" | "onHoverOut" | "onMarkerClick">
  & {
  entity: T;
  icon?: MarkerIcon | ((entity: T) => MarkerIcon | undefined);
  iconColor?: string | ((entity: T) => string | undefined)
  onHover?: (e: google.maps.MapMouseEvent, entity: T) => void;
  onHoverOut?: (e: google.maps.MapMouseEvent) => void;
  onMarkerClick?: (e: google.maps.MapMouseEvent, entity: T) => void;
};

export type EntityArrayMarkerProps<T extends LocatableEntity> = Omit<
  EntityMarkerProps<T>,
  "entity" | "position"
> &
  Pick<MarkerProps, "clusterer"> & {
  entities: T[];
};

export const EntityMarker = <T extends LocatableEntity, >(props: EntityMarkerProps<T>) => {
  const {
    entity,
    icon,
    onHover,
    onHoverOut,
    onMarkerClick,
    ...rest
  } = props;

  let markerIcon: MarkerIcon | undefined;

  // TODO: review for memo
  if (icon instanceof Function) {
    markerIcon = icon(entity);
  } else {
    markerIcon = icon;
  }

  return (
    <Marker
      {...rest}
      icon={markerIcon}
      onMouseOver={onHover ? (e) => onHover(e, entity) : undefined}
      onMouseOut={onHoverOut ? (e) => onHoverOut(e) : undefined}
      onClick={onMarkerClick ? (e) => onMarkerClick(e, entity) : undefined}
    />
  );
};
